export enum $academy {
  seatLimit = 'seatLimit',
  academyId = 'academyId',
  contentTags = 'contentTags',
  externalPackageSignupField = 'externalPackageSignupField',
  externalTenantGroupId = 'externalTenantGroupId',
}
